import { cn } from "@/shared/utils";
import { AnchorHTMLAttributes, PropsWithChildren } from "react";
import { Icon, IconName } from "./icon";

type LinkProps = PropsWithChildren<
    AnchorHTMLAttributes<HTMLAnchorElement> & {
        icon?: IconName;
    }
>;

export function TextLink({ children, icon, className, ...anchorProps }: LinkProps) {
    return (
        <a {...anchorProps} className={cn("text-content-interactive-default flex items-center gap-1", className)}>
            {icon && <Icon size="xs" name={icon} />}
            {children}
        </a>
    );
}
